import type { RegisterFormData } from './types';
import { validatePassword } from '../../utils/passwordRules';

/**
 * 单字段格式校验（纯函数）：返回错误消息，空串表示通过。
 * confirmPassword 需要交叉读取 formData.password 比对一致性。
 */
export function getFieldValueError(
  field: keyof RegisterFormData,
  value: string,
  formData: RegisterFormData,
): string {
  switch (field) {
    case 'fullName':
      if (!value.trim()) {
        return '请输入真实姓名';
      } else if (value.length < 2 || value.length > 50) {
        return '姓名长度必须在2到30个字符之间';
      }
      return '';

    case 'phone':
      if (!value.trim()) {
        return '请输入联系电话';
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        return '请输入正确的手机号';
      }
      return '';

    case 'backupPhone':
      if (value.trim()) {
        if (!/^1[3-9]\d{9}$/.test(value)) {
          return '请输入正确的备用电话';
        } else if (value === formData.phone) {
          return '备用电话不能与主电话相同';
        }
      }
      return '';

    case 'idCard':
      if (!value.trim()) {
        return '请输入身份证号';
      } else if (!/^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/.test(value)) {
        return '请输入正确的身份证号';
      } else {
        // 验证年龄是否年满18周岁
        const birthDateStr = value.substring(6, 14);
        const birthYear = parseInt(birthDateStr.substring(0, 4));
        const birthMonth = parseInt(birthDateStr.substring(4, 6));
        const birthDay = parseInt(birthDateStr.substring(6, 8));

        const birthDate = new Date(birthYear, birthMonth - 1, birthDay);
        const today = new Date();
        let age = today.getFullYear() - birthYear;
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDay)) {
          age--;
        }

        if (age < 18) {
          return '未满18周岁，无法注册';
        }
      }
      return '';

    case 'username':
      if (!value.trim()) {
        return '请设置用户名';
      } else if (value.length < 3 || value.length > 20) {
        return '用户名长度在3到20个字符之间';
      } else if (!/^[a-zA-Z0-9_]+$/.test(value)) {
        return '用户名只能包含字母、数字和下划线';
      }
      return '';

    case 'password': {
      const pwdErr = validatePassword(value);
      return pwdErr || '';
    }

    case 'confirmPassword':
      if (!value.trim()) {
        return '请确认密码';
      } else if (value !== formData.password) {
        return '两次输入的密码不一致';
      }
      return '';

    case 'email':
      if (!value.trim()) {
        return '请输入邮箱地址';
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return '请输入正确的邮箱地址';
      }
      return '';

    case 'emailCode':
      if (!value.trim()) {
        return '请输入邮箱验证码';
      } else if (!/^\d{6}$/.test(value.trim())) {
        return '验证码为 6 位数字';
      }
      return '';

    case 'smsCode':
      if (!value.trim()) {
        return '请输入短信验证码';
      } else if (!/^\d{6}$/.test(value.trim())) {
        return '验证码为 6 位数字';
      }
      return '';

    default:
      return '';
  }
}